
import moment from 'moment'

export default {

    namespaced:true,

    state: {

        

    },

    getters: {

        byKey: (state,getters,rootState,rootGetters) => ( search_keytype, search_key ) => 
        {
            var items = rootState.firebase.comments
            var output = []
            for( let key in items ) {
                let item = items[key]
                if( item.keytype != search_keytype ) continue
                if( item.key != search_key ) continue
                if( item.archived ) continue
                item['.key'] = key
                item.user = rootGetters['users/getOne']( item.user_key )
                item.created_human = moment(item.created,'YYYY-MM-DD').format('DD/MM/YY HH:mm')
                item.created_human2 = moment(item.created,'YYYY-MM-DD').fromNow()
                output.push(item)
            }
            return output

        },
        
    },

}


// WEBPACK FOOTER //
// ./src/store/modules/comments.js